// Account deletion — a thin adapter over valoi_engine's DELETE /api/v1/account.
// Browser-session only, same as tokensApi: the engine refuses this call when
// the caller authenticated with a developer token, so identity comes from the
// Bearer JWT via apiClient and this takes no arguments.

import { deleteJson } from '@/shared/api/apiClient';

export async function deleteAccount(): Promise<void> {
  // 204 on success; a still-active job comes back as a 409 whose `detail` is
  // already human copy (messageForApiError passes a string detail through
  // as-is), so no client-side mapping is needed for it.
  await deleteJson<void>('/api/v1/account');
}
